import alt, { AltStoreModel, AltActions } from '../../alt';
import URLHelpers from '../../shared/url_helpers';
import HashUtil from '../../../reverb-js-common/hash_util';

import { reject } from 'lodash';
import I18n from 'i18n-js';

import CoreClient from '../../../lib/core_client';
import { IFollowListStore, IFollowListActions } from '@reverbdotcom/commons';
import { flashSuccess } from '@reverbdotcom/commons/src/flash';

class FollowListActionsBase extends AltActions implements IFollowListActions {
  fail() {
    return null;
  }

  loaded() {
    return null;
  }

  setFollows(response) {
    return response;
  }

  // pass in the follow to be removed in the store
  // in an ideal world the API would return the current
  // set of follows and we wouldn't need to infer the
  // current state
  removeFollow(follow) {
    return follow;
  }

  setArticleFollows(categories) {
    return categories;
  }

  updateArticleFollows(categories) {
    const req = CoreClient.post(
      URLHelpers.articleFollowPath,
      { category_uuids: categories },
    );

    req.catch(() => this.fail());
    req.then(() => {
      flashSuccess(I18n.t('discovery.feedCustomization.articleSaveNotice'));
      this.setArticleFollows(categories);
    });

    return null;
  }

  deleteFollow(follow) {
    const req = CoreClient.destroy(HashUtil.getLink(follow, 'self'));
    req.catch(() => this.fail());
    req.then(() => this.removeFollow(follow));

    return null;
  }

  updateGearAlert(follow) {
    return follow;
  }

  fetch() {
    CoreClient.get(URLHelpers.feedCustomizePath)
      .then(response => this.setFollows(response))
      .catch(() => this.fail());

    return null;
  }

  addGearAlert(follow) {
    const req = CoreClient.post(HashUtil.getLink(follow, 'alert'))
      .then(follow => this.updateGearAlert(follow));
    req.catch(() => this.fail());

    return null;
  }

  removeGearAlert(follow) {
    const req = CoreClient.destroy(HashUtil.getLink(follow, 'alert'))
      .then(follow => this.updateGearAlert(follow));
    req.catch(() => this.fail());

    return null;
  }
}

export const FollowListActions = alt.createActions(FollowListActionsBase);

class FollowListStoreBase extends AltStoreModel<IFollowListStore> implements IFollowListStore {
  follow_groups = [];

  loaded = false;

  current_page = null;

  total = null;

  total_pages = null;

  article_follows = [];

  constructor() {
    super();
    this.bindActions(FollowListActions);
  }

  onSetFollows(response: IFollowListStore) {
    this.setState({ loaded: true, ...response });
  }

  onSetArticleFollows(categories) {
    this.setState({
      article_follows: categories,
    });
  }

  onRemoveFollow(follow) {
    const followGroups = this.follow_groups;

    followGroups.forEach((group) => {
      const follows = reject(group.follows, f => f === follow);
      group.follows = follows;
    });

    this.setState({ follow_groups: followGroups });
  }

  onFail() {
    this.setState({ loaded: true });
  }

  onLoaded() {
    this.setState({ loaded: true });
  }

  onUpdateGearAlert(follow) {
    const followGroups = this.follow_groups;

    followGroups.forEach((group) => {
      const follows = group.follows.map((f) => {
        if (f._links.self.href === follow._links.self.href) {
          return follow;
        }
        return f;
      });

      group.follows = follows;
    });

    this.setState({ follow_groups: followGroups });
  }
}

export const FollowListStore = alt.createStore(FollowListStoreBase, 'FollowListStore');
